export default __webpack_public_path__ + "static/media/3.8e40a3ff.svg";